import * as React from 'react';
import { SVGProps } from 'react';

const SvgPoorConnectivitySolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM6.03 6.738a.5.5 0 0 1 .708-.707l11.231 11.231a.5.5 0 0 1-.707.707L6.031 6.738Zm1.621 2.54c-.51.27-.995.59-1.45.955a.607.607 0 1 0 .76.947 8.042 8.042 0 0 1 1.594-.998l-.904-.904Zm2.062 2.062a6.527 6.527 0 0 0-2.134 1.31.607.607 0 0 0 .822.893 5.311 5.311 0 0 1 2.28-1.236l-.968-.967Zm4.576 1.322-1.708-1.708a6.527 6.527 0 0 1 3.81 1.676.607.607 0 0 1-.817.898 5.314 5.314 0 0 0-1.285-.866Zm-2.255.998 2.14 2.141a.604.604 0 0 1-.356-.172 2.585 2.585 0 0 0-2.44-.68 2.584 2.584 0 0 0-1.205.68.607.607 0 0 1-.857-.86 3.8 3.8 0 0 1 2.68-1.109h.037Zm-.947-4.2-1.055-1.055a9.258 9.258 0 0 1 7.767 1.832.607.607 0 1 1-.76.947 8.045 8.045 0 0 0-5.952-1.724Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPoorConnectivitySolidIcon;
